<template>
    <div class="index">

        <!-- 顶部导航栏 -->
        <header id="header">
            <a href="#">批车侠</a>
            <nav>
                <a href="#">首页</a>
                <a @click="jumpIntro">批车侠</a>
                <a @click="jumpCompany">公司简介</a>
            </nav>
        </header>

        <!-- 图片及介绍 -->
        <div class="container">
            <div class="content">
                <p>批车侠</p>
                <p>
                    实现各平台的数据交汇及共享，<br>
                    为促进政务数据协同、营商环境优化、金融服务建设可信体系提供技术支持。
                </p>
            </div>
        </div>

        <!-- 服务介绍 -->
        <div id="content2" class="part-body">
            <div class="title">
                <span>批车侠介绍</span>
            </div>
            <div class="part">
                <div>
                    <div class="part-content position-l">
                        <span>车辆检测</span>
                        <p>购车先检测，车况更安心</p>
                        <p>专业检测，避免买到事故车、火烧车、泡水车</p>
                    </div>
                </div>
                <img src="../assets/inquiry_service.png" alt="">
            </div>
            <div class="part">
                <img src="../assets/break_rules.png" alt="">
                <div>
                    <div class="part-content position-r">
                        <span>车辆估价</span>
                        <p>买车卖车先估价，掌握车价，买卖有底</p>
                        <p>基于大数据和人工智能技术，车辆估值真实、准确、可靠</p>
                    </div>
                </div>
            </div>
            <div class="part">
                <div>
                    <div class="part-content position-l">
                        <span>批发车源</span>
                        <p>海量车源，一手批发</p>
                        <p>汇聚全国优质二手车源，批量采购更优惠，助力车商快速收车、高效卖车</p>
                    </div>
                </div>
                <img src="../assets/car_condition.png" alt="">
            </div>
        </div>

        <!-- 车源列表 -->
        <div id="car-list" class="car-list-section">
            <div class="section-title">
                <span>精选车源</span>
            </div>
            <div class="car-grid">
                <div class="car-card" v-for="car in cars" :key="car.car_id">
                    <div class="car-image">
                        <img :src="car.car_pic" :alt="car.car_name">
                        <span v-if="car.is_new" class="new-tag">新车源</span>
                    </div>
                    <div class="car-info">
                        <h3 class="car-name">{{ car.car_name }}</h3>
                        <p class="car-desc">{{ car.desc }}</p>
                        <div class="car-footer">
                            <span class="car-price">{{ car.price_desc }}</span>
                            <span class="car-city">{{ car.city_name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-more-container">
                <button class="view-more-btn" @click="viewMore">查看更多</button>
            </div>
        </div>

        <!-- 公司简介 -->
        <div id="content3" class="introduction">
            <h2>公司简介</h2>
            <p>
                南京车速批信息科技有限公司成立于2025年1月，<br>
                作为响应“互联网+数据服务”号召的创新产品，致力于解决二手车市场信息不对称问题，<br>
                帮助每一位用户在体验产品的同时，还可以得到更多的增值服务，如车辆检测、车源批发、车型识别、违章查询、车辆金融评估等。
            </p>
        </div>

        <!-- 弹窗 -->
        <div v-if="showModal" class="modal-overlay" @click="closeModal">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <span>提示</span>
                    <button class="close-btn" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <div class="qrcode-placeholder">
                        <img src="../assets/gh_079dd9c31945_860.jpg" alt="小程序码" class="qrcode-img">
                    </div>
                    <p class="modal-text">请扫描小程序码查看更多车源</p>
                </div>
            </div>
        </div>

        <!-- 联系我们 -->
        <footer id="footer">
            <ul>
                <li class="footer-title">联系我们</li>
                <li class="footer-contact">联系方式：13655181440</li>
                <li class="footer-contact">邮箱：shaliangliang@pichexia.com</li>
                <li class="footer-contact">地址：南京市鼓楼区古平岗4号智梦园C座605室</li>
            </ul>
            <span>备案号：<a class="split-mark" href="http://beian.miit.gov.cn" target="_blank"> {{beian}} </a></span>
            <!-- | <a :href="`https://beian.mps.gov.cn/#/query/webSearch?code=${gabeian}`" rel="noreferrer" target="_blank">苏公网安备 {{ gabeian }}号</a> -->
        </footer>
    </div>
</template>

<script>
import carData from '../data.json';

export default {
    name: 'Home',
    data: function() {
        return {
            beian: '苏ICP备2025157719号',
            gabeian: '32010602011344',
            cars: carData.slice(0, 20),
            showModal: false
        };
    },
    methods: { 
        jumpIntro() {
            document.querySelector("#content2").scrollIntoView(true);
        },
        jumpCompany() {
            document.querySelector("#content3").scrollIntoView(true);
        },
        viewMore() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        }
    }
}
</script>

<style lang="less" scoped>
.index {
    overflow: hidden;
}
header {
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    a {
        cursor: pointer;
    }
    nav {
        a {
            color: #222;
            opacity: 0.7;
            margin-left: 30px;
            margin-right: 30px;
        }
    }
}
.bg-img {
    width: 100%;
    height: 640px;
}
.container {
    background: url("../assets/banner_chelian.png");
    background-repeat: no-repeat;
    background-position: top;
    height: 480px;
    width: 100%;
    color: #fff;
    position: relative;
    .content {
        position: absolute;
        top: 50%;
        left: 260px;
        transform: translateY(-50%);
        font-size: 32px;
        p:first-child {
            font-size: 48px;
            font-weight: 500;
            margin-bottom: 20px;
        }
        p:last-child {
            font-size: 20px;
            font-weight: normal;
            line-height: 30px;
        }
    }
}
.part-body {
    padding: 60px 260px 0;
    min-width: 1080px;
    .title {
        font-size: 24px;
        color: #222;
        margin-bottom: 40px;
    }
    .list {
        display: flex;
        justify-content: space-between;
    }
    .list-item {
        width: 18%;
        box-shadow: 0 5px 26px 0 rgba(68, 88, 144, 0.14);
        text-align: center;
        padding: 30px;
        span {
            display: block;
            width: 72px;
            height: 72px;
            border-radius: 36px;
            position: relative;
            margin: 0 auto 15px;
        }
        img {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .item1:hover {
        border: 1px solid #1296db;
    }
    .item2:hover {
        border: 1px solid #d4237a;
    }
    .item3:hover {
        border: 1px solid #41cf2e;
    }
    .item4:hover {
        border: 1px solid #3fcdc7;
    }
    .part {
        display: flex;
        justify-content: space-between;
        position: relative;
        img {
            width: 500px;
            height: 500px;
        }
    }
    .part:nth-child(3) {
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .part-content {
        width: 470px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        span {
            font-size: 36px;
            margin-bottom: 30px;
            display: block;
        }
        p {
            color: #6b7799;
            line-height: 30px;
        }
    }
    .position-l {
        left: 0;
    }
    .position-r {
        right: 0;
    }
}
.introduction {
    margin-top: 40px;
    text-align: center;
    padding: 30px 0 80px;
    background-color: #fff;
    p {
        line-height: 30px;
    }
}
footer {
    background-color: #2b303b;
    color: #bbb;
    padding: 50px 260px 20px;
    font-size: 12px;
    ul {
        border-bottom: 1px solid #666;
    }
    a{
        color: #bbb;
    }
    .footer-title {
        margin-bottom: 30px;
        line-height: 14px;
        font-size: 14px;
    }
    .footer-contact {
        margin-bottom: 20px;
    }
}

/* 车源列表样式 */
.car-list-section {
    padding: 60px 20px;
    background-color: #f8f9fa;
    .section-title {
        font-size: 24px;
        color: #222;
        margin-bottom: 30px;
        text-align: center;
    }
    .car-grid {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 16px;
        justify-items: center;
        max-width: 1400px;
        margin: 0 auto;
    }
    /* 超小屏幕 (手机) */
    @media (min-width: 576px) {
        .car-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
    /* 小屏幕 (平板) */
    @media (min-width: 768px) {
        padding: 60px 40px;
        .car-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
        }
    }
    /* 中等屏幕 (桌面) */
    @media (min-width: 992px) {
        padding: 60px 60px;
        .car-grid {
            grid-template-columns: repeat(4, 1fr);
        }
    }
    /* 大屏幕 */
    @media (min-width: 1200px) {
        padding: 60px 100px;
        .car-grid {
            grid-template-columns: repeat(5, 1fr);
        }
    }
    .car-card {
        width: 100%;
        max-width: 280px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        transition: transform 0.2s, box-shadow 0.2s;
        &:hover {
            transform: translateY(-4px);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
        }
        .car-image {
            position: relative;
            width: 100%;
            height: 150px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .new-tag {
                position: absolute;
                top: 8px;
                left: 8px;
                background-color: #ff6b6b;
                color: #fff;
                font-size: 12px;
                padding: 2px 8px;
                border-radius: 4px;
            }
        }
        .car-info {
            padding: 12px;
            .car-name {
                font-size: 14px;
                font-weight: 500;
                color: #222;
                margin-bottom: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .car-desc {
                font-size: 12px;
                color: #999;
                margin-bottom: 10px;
            }
            .car-footer {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .car-price {
                    font-size: 16px;
                    font-weight: 600;
                    color: #ff6b6b;
                }
                .car-city {
                    font-size: 12px;
                    color: #999;
                }
            }
        }
    }
    .view-more-container {
        text-align: center;
        margin-top: 40px;
        .view-more-btn {
            padding: 12px 40px;
            background-color: #1296db;
            color: #fff;
            border: none;
            border-radius: 25px;
            font-size: 16px;
            cursor: pointer;
            transition: background-color 0.2s;
            &:hover {
                background-color: #0e7bb8;
            }
        }
    }
}

/* 弹窗样式 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    .modal-content {
        background-color: #fff;
        border-radius: 12px;
        width: 90%;
        max-width: 360px;
        overflow: hidden;
        .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;
            border-bottom: 1px solid #eee;
            span {
                font-size: 16px;
                font-weight: 500;
                color: #222;
            }
            .close-btn {
                width: 28px;
                height: 28px;
                border: none;
                background-color: #f5f5f5;
                border-radius: 50%;
                font-size: 20px;
                color: #666;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover {
                    background-color: #eee;
                }
            }
        }
        .modal-body {
            padding: 24px;
            text-align: center;
            .qrcode-placeholder {
                width: 180px;
                height: 180px;
                margin: 0 auto 16px;
                background-color: #f8f9fa;
                border-radius: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                .qrcode-img {
                    width: 160px;
                    height: 160px;
                    border-radius: 8px;
                }
            }
            .modal-text {
                font-size: 14px;
                color: #666;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue